import { Component, OnInit, SecurityContext } from '@angular/core'
import {
  AuthService,
  CmsNavigationComponent,
  Product,
  CmsService,
  GlobalMessageService,
  GlobalMessageType,
  AuthRedirectService,
  AuthStorageService,
  OccEndpointsService,
  UserIdService,
  OAuthLibWrapperService,
  OCC_USER_ID_CURRENT,
  AuthActions,
} from '@spartacus/core'
import { Observable, Subject, Subscription } from 'rxjs'
import { CmsComponentData } from '@spartacus/storefront'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { DomSanitizer } from '@angular/platform-browser'
import { Store } from '@ngrx/store'
import { CommonService } from '../../../shared/services/common.service'
import { environment } from '../../../../environments/environment'
import { GtmEvents, LoginMethod } from '../../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../../shared/services/gtm.service';

@Component({
  standalone: false,

  selector: 'vs-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent implements OnInit {
  data$: Observable<CmsNavigationComponent> = this.componentData.data$
  loginForm: FormGroup
  loginComponentData$: any
  termsContentData = 'ABC'
  observable$: Observable<any>
  unsubscribe$: Subject<void> = new Subject<void>()
  sub: Subscription
  useSSOLogin = environment.checkSSO
  disableSubmit = true

  constructor(
    private componentData: CmsComponentData<CmsNavigationComponent>,
    private cmsService: CmsService,
    private formBuilder: FormBuilder,
    protected auth: AuthService,
    protected authRedirectService: AuthRedirectService,
    protected globalMessageService: GlobalMessageService,
    private commonService: CommonService,
    private authStorageService: AuthStorageService,
    private domSanitizer: DomSanitizer,
    private occEndpointsService: OccEndpointsService,
    private store: Store,
    private userIdService: UserIdService,
    private oAuthLibWrapperService: OAuthLibWrapperService,
    private gtmService: GoogleTagManagerService,
  ) {}

  ngOnInit(): void {
    // this.loginComponentData$ =
    //   this.cmsService.getComponentData<any>('LoginFormComponent')

    if (!this.useSSOLogin) {
      this.loginForm = this.formBuilder.group({
        termsAgreementRadioGroup: [null, Validators.required],
        userId: [null, Validators.required],
        password: [null, Validators.required],
      })
      this.disableSubmit = false
    } else {
      this.loginForm = this.formBuilder.group({
        termsAgreementRadioGroup: [null, Validators.required],
      })

      this.loginForm
        .get('termsAgreementRadioGroup')
        .valueChanges.subscribe((val) => {
          if (!val || val === false || val === 'false') {
            this.disableSubmit = true
          } else {
            this.disableSubmit = false
          }
        })
    }
  }

  submitTermsForm(): void {
    if (!this.useSSOLogin) {
      if (this.loginForm.valid) {
        this.loginUser()
      }
    } else {
      const urlParams = ['vslogin', 'redirect_login']
      const loginUrl = this.commonService.constructUrl(urlParams)
      window.location.href = this.domSanitizer.sanitize(
        SecurityContext.URL,
        loginUrl
      )
    }
  }

  protected async loginUser(): Promise<void> {
    const { userId, password } = this.loginForm.controls
    // this.auth.loginWithCredentials(userId.value.toLowerCase(), password.value)
    try {
      await this.oAuthLibWrapperService.authorizeWithPasswordFlow(
        userId.value,
        password.value
      )

      // OCC specific user id handling. Customize when implementing different backend
      this.userIdService.setUserId(OCC_USER_ID_CURRENT)

      this.store.dispatch(new AuthActions.Login())

      this.gtmService.sendEvent({
        event: GtmEvents.Login,
        authentication_method: LoginMethod.Local,
        user_id: userId.value,
      });

      this.authRedirectService.redirect()
    } catch(error) {
      this.gtmService.sendEvent({
        event: GtmEvents.LoginError,
        authentication_method: LoginMethod.Local,
        user_id: userId.value,
      });
    }
  }

  getGDPRDoc() {
    window.open('/assets/docs/GDPR.pdf', '_blank')
  }
}
